import React from 'react';

import { Link, styled } from '@mui/material';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import ArrowCorner from 'components/SvgComponents/icons/ArrowCorner';
import { FONTSIZE_S } from 'theme/typography';
import globalMessages from 'translations/messages/global-messages';

// #region [styled]
const Button_LearnMore = styled('span')(({ theme }) => ({
  textAlign: 'left',
  fontSize: FONTSIZE_S,
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.text.info,
  width: 'fit-content',
  padding: '4px',
  '&:hover': {
    color: theme.palette.link.hover,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.text.info}`,
  },
  '&:visited': {
    color: theme.palette.link.visited,
  },
  '&:active': {
    color: theme.palette.link.active,
  },
  '& svg': {
    verticalAlign: 'text-bottom',
  },
}));

const Span_NoUnderline = styled('span')(() => ({
  display: 'inline-block',
  '&:hover': {
    textDecoration: 'none',
  },
}));

// #endregion

const LearnMore = ({ children, intl, onClick }) => {
  return (
    <Button_LearnMore onClick={onClick} component={Link} variant="info plain">
      {children || intl.formatMessage(globalMessages.learn_more)}
      <Span_NoUnderline>&nbsp;</Span_NoUnderline>
      <ArrowCorner color="inherit" />
    </Button_LearnMore>
  );
};

LearnMore.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  intl: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default injectIntl(LearnMore);
